import { axios } from '@Root/API'

export const getAll = (courseSessionId, params) => {
	return axios.get(`/get/study-location/student-course-session/${courseSessionId}`, { params })
}
